
// banners
import headerBanner from "../assets/website-bg-compressed.jpg"

// proejct thumbnails
import projectDefaultThumbnail from "../assets/thumbnails/default-thumbnail_compressed.jpg"
import twinlandeThumbnail from "../assets/thumbnails/twinlande-thumbnail_compressed.jpg"
import chevEscapeThumbnail from  "../assets/thumbnails/chev-escape-thumbnail.jpg";
import colonialCarnivalThumbnail from "../assets/thumbnails/colonial-carnival-thmbnl.jpg";
import pawbytesCafeThumbnail from "../assets/thumbnails/pawbytes--cafe-thmbnl.jpg";
import gitrg3DCrayonThumbnail from "../assets/thumbnails/gitrg-3d-crayon-compressed.jpg";
import mocapThumbnail from "../assets/thumbnails/mocap-thumbnail.jpg";
import revealingRocThumbnail from "../assets/thumbnails/revealing-roc-thumbnail.jpg";


import serverLogoIcon from "../assets/rs-icon-compressed.jpg";



export const useImageRetriever = () => {
  return {
    headerBanner,
    projectDefaultThumbnail,
    twinlandeThumbnail,
    chevEscapeThumbnail,
    colonialCarnivalThumbnail,
    pawbytesCafeThumbnail,
    gitrg3DCrayonThumbnail,
    mocapThumbnail,
    revealingRocThumbnail,
    serverLogoIcon
  }
}